import { useContext } from 'react';
import { Card, Nav, ProgressBar, Spinner } from 'react-bootstrap';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NewSerpContext } from '@/context/Context';

interface SerpProgressBarProps {
  progressBar?: boolean;
}

const SerpProgressBar = ({ progressBar }: SerpProgressBarProps) => {
  const { step } = useContext(NewSerpContext);
  const navItems = [
    'ارسال درخواست',
    'دریافت اطلاعات نتایج',
    'دریافت اطلاعات دامنه ها',
    'دریافت اطلاعات صفحات'
  ];

  return (
    <>
      <style>
        {`
      .theme-wizard .nav-link.active:not(.nav-pills .active){
        color: var(--falcon-navbar-vertical-default-link-active-color)
      }
      .theme-wizard .nav-link.active .nav-item-circle{
        background-color: var(--falcon-navbar-vertical-default-link-active-color) !important
      }
      `}
      </style>
      <Card className="theme-wizard mb-5">
        <Card.Header className={classNames('bg-body-tertiary')}>
          <Nav className="justify-content-center">
            {navItems.map((item, index) => (
              <NavItem key={index} index={index + 1} step={step} label={item} />
            ))}
          </Nav>
        </Card.Header>
        {progressBar && <ProgressBar now={step * 25} style={{ height: 2 }} />}
      </Card>
    </>
  );
};

interface NavItemProps {
  index: number;
  step: number;
  label: string;
}

const NavItem = ({ index, step, label }: NavItemProps) => {
  return (
    <Nav.Item>
      <Nav.Link
        className={classNames('fw-semibold', {
          done: index < 4 ? step > index : step > 3,
          active: step === index
        })}
        onClick={() => {}}
      >
        <span className="nav-item-circle-parent p-0 p-md-1">
          {index < step ? (
            <span className="nav-item-circle">
              <FontAwesomeIcon icon="check" />
            </span>
          ) : index === step ? (
            <span className="nav-item-circle">
              <Spinner
                animation="border"
                role="status"
                style={{ color: '#121e2d', verticalAlign: 'middle' }}
              ></Spinner>
            </span>
          ) : (
            <span className="nav-item-circle">
              <FontAwesomeIcon icon="check" />
            </span>
          )}
        </span>
        <span className="d-none d-md-block mt-1 fs-10">{label}</span>
      </Nav.Link>
    </Nav.Item>
  );
};

export default SerpProgressBar;
